import { TextField, TextFieldProps } from "@mui/material";
import { useField } from "@unform/core"
import React, { useCallback, useEffect, useRef, useState } from "react";
import { cep, number, mascara, currency, maskCelular, maskCep, maskDddCel, moedaRealLocale, moedaRealLocaleValue } from "../components/input-valor-moeda/Current-Mask";


type TVTextFieldProps = TextFieldProps & {
    name: string;
    typeMask: "cep" | "currency" | "celular" | "dddCel" | "number";
    prefix?: string;
    maxLength?: number
}


//Componentes Unform
export const VInputCurrency: React.FC<TVTextFieldProps> = ({ name, typeMask, prefix, maxLength, ...rest }) => {
    const inputRef = useRef(null);
    const { fieldName, registerField, defaultValue, error, clearError } = useField(name);
    const [value, setValue] = useState(defaultValue || "");

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef,
            getValue: () => value,
            setValue: (e, newValue) => {
                setValue(newValue !== undefined ?
                    typeMask === "currency" ? moedaRealLocaleValue(newValue.toString()) :
                        typeMask === "cep" ? maskCep(newValue) :
                            typeMask === "celular" ? maskCelular(newValue) :
                                typeMask === "dddCel" ? maskDddCel(newValue) : newValue : newValue);
                //isNaN(parseFloat(newValue)) ?  newValue : moedaRealLocale(newValue)  )
            },
        });

    }, [registerField, fieldName, value])


    const handleKeyUp = useCallback((e: any) => {


        if (typeMask === "number") {
            number(e);
        }
        else if (typeMask === "cep") {
            cep(e);
        }


    }, []);


    return (
        <>
            {/* {prefix && <span>{prefix}</span>} */}
            <TextField
                ref={inputRef}
                defaultValue={defaultValue}
                {...rest}
                error={!!error}
                helperText={error}
                size={"small"}
                onKeyDown={(e) => { error && clearError(); rest.onKeyDown?.(e); }}
                onKeyUp={handleKeyUp}
                value={value}
                onChange={(e) => {
                    (setValue(typeMask === "number" ? number(e).target.value :
                        typeMask === "cep" ? maskCep(e.target.value) :
                            typeMask === "celular" ? maskCelular(e.target.value) :
                                maskDddCel(e.target.value)
                    ));
                    rest.onChange?.(e);
                }}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                    htmlInput: {
                        step: 2
                    }
                }}
            />
        </>
    );
};